module.exports = __webpack_public_path__ + "assets/img/coach.0792e01c.png";